// UP, SAME, DOWN, RESET should not be special regex characters in a character class.
export var UP = "<"; // one level up
export var SAME = ","; // same level
export var DOWN = ">"; // one level down
export var RESET = "|"; // reset level index and start new
export var WILDCARD = "*"; // as defined by publicsuffix.org
export var EXCEPTION = "!"; // as defined by publicsuffix.org